import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
// @material-ui/core components
import {
  Grid,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Table,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../../assets/jss/components/tableStyle";
import styles from "../../../../../assets/jss/layouts/appStyle";
// core components
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
} from "../../../../../common/actions/CommonActions";
import { LOCALE } from "../../../../../properties/Locale";
import Card from "../../../../../common/components/Card/Card.js";
import CardHeader from "../../../../../common/components/Card/CardHeader.js";
import CardBody from "../../../../../common/components/Card/CardBody.js";
import { GradingSchemaRepository } from "../../../gradingSchema/GradingSchemaRepository";

const useStyles = makeStyles(styles, tableStyles);

export default function ProfessionalTitleSchemaPointComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [gradingSchemaId] = useState(props.gradingSchemaId);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [btnSubmitLoading, setBtnSubmitLoading] = useState(true);
  const [rerender, triggerRerender] = React.useState(false);

  useEffect(() => {
    const loadGradingSchema = (id) => {
      showLoadingBar(true);
      GradingSchemaRepository.fetchProfessionalTitle(id).then((res) => {
        setData(res.data);
        hideLoadingBar(false);
      });
    };
    loadGradingSchema(gradingSchemaId);
  }, [gradingSchemaId]);

  const handleSave = () => {
    showLoadingBar();
    GradingSchemaRepository.updateProfessionalTitle(gradingSchemaId, data)
      .then((res) => {
        hideLoadingBar();
        dispatch(
          notifyShowSuccessMessage(LOCALE.schema_points_update_success_message)
        );
      })
      .catch((err) => {
        hideLoadingBar();
        dispatch(notifyShowErrorMessage(err.message));
      });
  };

  const handleChange = (event, index, name) => {
    let tmpData = data;
    tmpData[index][name] = event.target.value;
    setData(tmpData);
    triggerRerender(!rerender);
  };

  const showLoadingBar = () => {
    setLoading(true);
    setBtnSubmitLoading(true);
  };

  const hideLoadingBar = () => {
    setLoading(false);
    setBtnSubmitLoading(false);
  };

  return (
    <Grid item md={12} style={{ paddingTop: "25px" }}>
      <Card>
        <CardHeader color="theme">
          <h4 className={classes.cardTitleWhite}>
            {`${LOCALE.schema_points}${":" + LOCALE.professional_title}`}
          </h4>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.professional_title_type}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.professional_title_area}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.defaultPoints}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.maxPoints}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((professionalTitle, index) => (
                <TableRow
                  key={professionalTitle.id}
                  className={classes.tableBodyRow}
                  style={index % 2 ? { background: "#f0f0f0" } : {}}
                >
                  <TableCell className={classes.tableCell}>
                    {professionalTitle?.type?.name}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {professionalTitle?.area?.name}
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ minWidth: "84px", width: "84px" }}
                  >
                    <TextField
                      size="small"
                      fullWidth={true}
                      value={professionalTitle?.defaultPoints}
                      onChange={(event) =>
                        handleChange(event, index, "defaultPoints")
                      }
                      margin="normal"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ minWidth: "84px", width: "84px" }}
                  >
                    <TextField
                      size="small"
                      fullWidth={true}
                      value={professionalTitle?.maxPoints}
                      onChange={(event) =>
                        handleChange(event, index, "maxPoints")
                      }
                      margin="normal"
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div style={{ paddingTop: "10px" }}>
            <Button
              style={{ marginRight: "5px", float: "right" }}
              type="submit"
              size="small"
              variant="contained"
              disabled={btnSubmitLoading}
              className={btnSubmitLoading ? "btn-loading" : ""}
              color="primary"
              onClick={() => handleSave()}
            >
              {LOCALE.save}
              {btnSubmitLoading && (
                <CircularProgress
                  color="secondary"
                  size={20}
                  style={{ position: "absolute" }}
                />
              )}
            </Button>
            <Link
              to={`/app/configuration/gradingSchema`}
              style={{ textDecoration: "none" }}
            >
              <Button
                style={{ marginRight: "5px", float: "right" }}
                color="secondary"
                variant="outlined"
                size="small"
              >
                {LOCALE.back}
              </Button>
            </Link>
          </div>
        </CardBody>
      </Card>
    </Grid>
  );
}
